import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flori',
  templateUrl: './flori.component.html',
  styleUrls: ['./flori.component.scss']
})
export class FloriComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
